/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * FastMile API
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  GetApiUserUserInfoParams,
  UserInfoDto,
} from '../../models/generated'

import { fastmileInstance } from '../../fastmileInstance'

export const getApiUserUserInfo = (
  params?: GetApiUserUserInfoParams,
  signal?: AbortSignal,
) => {
  return fastmileInstance<UserInfoDto>({
    url: '/api/User/user-info',
    method: 'GET',
    params,
    signal,
  })
}

export const getGetApiUserUserInfoQueryKey = (
  params?: GetApiUserUserInfoParams,
) => {
  return ['/api/User/user-info', ...(params ? [params] : [])] as const
}

export const getGetApiUserUserInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserUserInfo>>,
  TError = unknown,
>(
    params?: GetApiUserUserInfoParams,
    options?: {
      query?: Partial<
      UseQueryOptions<
      Awaited<ReturnType<typeof getApiUserUserInfo>>,
      TError,
      TData
      >
      >;
    },
  ) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetApiUserUserInfoQueryKey(params)

  const queryFn: QueryFunction<
  Awaited<ReturnType<typeof getApiUserUserInfo>>
  > = ({ signal }) => getApiUserUserInfo(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
  Awaited<ReturnType<typeof getApiUserUserInfo>>,
  TError,
  TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiUserUserInfoQueryResult = NonNullable<
Awaited<ReturnType<typeof getApiUserUserInfo>>
>
export type GetApiUserUserInfoQueryError = unknown

export function useGetApiUserUserInfo<
  TData = Awaited<ReturnType<typeof getApiUserUserInfo>>,
  TError = unknown,
>(
  params: undefined | GetApiUserUserInfoParams,
  options: {
    query: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserUserInfo>>,
    TError,
    TData
    >
    > &
    Pick<
    DefinedInitialDataOptions<
    Awaited<ReturnType<typeof getApiUserUserInfo>>,
    TError,
    Awaited<ReturnType<typeof getApiUserUserInfo>>
    >,
    'initialData'
    >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiUserUserInfo<
  TData = Awaited<ReturnType<typeof getApiUserUserInfo>>,
  TError = unknown,
>(
  params?: GetApiUserUserInfoParams,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserUserInfo>>,
    TError,
    TData
    >
    > &
    Pick<
    UndefinedInitialDataOptions<
    Awaited<ReturnType<typeof getApiUserUserInfo>>,
    TError,
    Awaited<ReturnType<typeof getApiUserUserInfo>>
    >,
    'initialData'
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiUserUserInfo<
  TData = Awaited<ReturnType<typeof getApiUserUserInfo>>,
  TError = unknown,
>(
  params?: GetApiUserUserInfoParams,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserUserInfo>>,
    TError,
    TData
    >
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}

export function useGetApiUserUserInfo<
  TData = Awaited<ReturnType<typeof getApiUserUserInfo>>,
  TError = unknown,
>(
  params?: GetApiUserUserInfoParams,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserUserInfo>>,
    TError,
    TData
    >
    >;
  },
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } {
  const queryOptions = getGetApiUserUserInfoQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  }

  query.queryKey = queryOptions.queryKey

  return query
}
